import React from 'react';
import styles from './error.module.scss';
import { useTranslation } from 'react-i18next';
import PrimaryButton from '../buttons/PrimaryButton';
import ErrorSupportLink from './ErrorSupportLink';
import ErrorCode from './ErrorCode';
import FeatherIcon from "feather-icons-react";

interface IProps {
  code?: string
  finishConnection: () => void,
}

const LoadingError: React.FC<IProps> = (props: IProps) => {
  const { t } = useTranslation();

  return (
    <div className={styles.screen} data-testid='error-container'>
      <div className={styles.topWrapper}>
          <FeatherIcon icon="alert-triangle" className={styles.icon} />
          <h1 className={styles.uppercase}>{t<string>('Unable to connect')}</h1>
        <div className={styles.content}>
          <p>{t<string>('Sorry, we were unable to initialise the bank sharing process.')}</p>
          <p><>
            {t<string>('The service has not been configured correctly.')}
            <ErrorCode errorCode={props.code} /></>
          </p>
          <p><>{t<string>('Please contact our')} <ErrorSupportLink errorCode={props.code} /></></p>
        </div>
      </div>
      <div className={styles.buttonWrapper}>
        <PrimaryButton onClick={props.finishConnection}>{t<string>('Quit')}</PrimaryButton>
      </div>
    </div>
  );
};

export default LoadingError;
